import React from 'react';
import useClassNames, { IClassNames } from '../../hooks/classNames.hooks';
import './style.scss';

interface BoxProps extends IClassNames {}

const Box: React.FC<BoxProps> = ({ classNames, children, ...props }) => {
  const { className } = useClassNames('ckp-a-box', classNames);

  return (
    <article className={className} {...props}>
      {children}
    </article>
  );
};

export default Box;
